module.exports = __webpack_public_path__ + "img/account_sales.fe010433.svg";